import { red, lightGray } from '../../../colors';

export default {
	paperContainer: {
		marginBottom: 5,
		padding: '5px 5px 10px 10px',
	},
	subTitle: {
		marginTop: 5,
		marginBottom: 0,
	},
	subTitleIn: {
		marginTop: 5,
		marginBottom: -4,
	},
	columnAdjust: {
		paddingLeft: 10,
		paddingRight: 10,
		marginTop: 5,
	},
	outlineError: {
		outline: `solid ${red} 2px`,
	},
	RefreshIndicator: {
		zIndex: 2000,
		marginTop: '35%',
		marginLeft: '48%',
	},
	dialogPaper: {
		overflowY: 'visible',
		width: '100%',
		maxWidth: 940,
	},
	dialogActionsRoot: {
		width: '100%',
	},
	dialogContent: {
		borderTop: `1px solid ${lightGray}`,
		borderBottom: `1px solid ${lightGray}`,
	},
	pciTelecomIconContainer: {
		display: 'flex',
		justifyContent: 'center',
		marginBottom: 16,
	},
	pciTelecomStatusBox: {
		marginBottom: 16,
		textAlign: 'center',
	},
	pciTelecomStatusText: {
		marginBottom: 16,
		textAlign: 'center',
		fontWeight: 300,
		fontSize: 13,
		lineHeight: '19px',
	},
	pciTelecomBodyText: {
		fontWeight: 300,
		fontSize: 13,
		lineHeight: '19px',
	},
	pciTelecomDialogContent: {
		paddingLeft: 16,
		paddingRight: 16,
		paddingBottom: 16,
	},
	pciTelecomDialogActions: {
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: 16,
	},
};
